module.exports = __webpack_public_path__ + "static/media/idee.e79a8a60.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/mp3/idee.mp3
// module id = 36
// module chunks = 0